import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import remarkBreaks from 'remark-breaks';
import { cn } from '@/lib/cn';

/**
 * Renders markdown content (ingested docs, transcripts, suggestion bodies) with sane
 * defaults. `remark-breaks` keeps single newlines as line breaks so speaker-per-line
 * transcripts read correctly; `remark-gfm` adds tables/strikethrough/task-lists.
 * Styled via @tailwindcss/typography; `dark:prose-invert` follows the app theme.
 */
/** Strip a leading YAML frontmatter block (--- ... ---) so it isn't rendered as text. */
function stripFrontmatter(s: string): string {
  return s.replace(/^﻿?---\r?\n[\s\S]*?\r?\n---\r?\n?/, '');
}

export function Markdown({ children, className }: { children: string; className?: string }) {
  const body = stripFrontmatter(children);
  return (
    <div
      className={cn(
        'prose prose-sm max-w-none dark:prose-invert prose-headings:font-semibold prose-pre:bg-surface-2 prose-code:text-fg',
        className,
      )}
    >
      <ReactMarkdown remarkPlugins={[remarkGfm, remarkBreaks]}>{body}</ReactMarkdown>
    </div>
  );
}
